export default {
  key: 'primary_demand',
  slug: 'primary-demand',
  variants: [
    {
      key: 'by_carrier',
      slug: 'by-carrier',
      series: [
        'myc_primary_demand_of_ammonia',
        'myc_primary_demand_of_biogas',
        'myc_primary_demand_of_coal_and_coal_products',
        'myc_primary_demand_of_electricity',
        'myc_primary_demand_of_geothermal_electricity',
        'myc_primary_demand_of_geothermal_heat',
        'myc_primary_demand_of_heat',
        'myc_primary_demand_of_hydro_electricity',
        'myc_primary_demand_of_hydrogen_carriers',
        'myc_primary_demand_of_liquid_biofuels',
        'myc_primary_demand_of_methanol',
        'myc_primary_demand_of_natural_gas_and_derivatives',
        'myc_primary_demand_of_nuclear_energy',
        'myc_primary_demand_of_oil_and_oil_products',
        'myc_primary_demand_of_solar_electricity',
        'myc_primary_demand_of_solar_thermal',
        'myc_primary_demand_of_solid_biofuels',
        'myc_primary_demand_of_waste',
        'myc_primary_demand_of_wind_electricity'
      ]
    }
  ]
};
